import { createSelector } from 'reselect';
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../util/constants';

export const packageListSelector = (state) => state.videoService.packages || EMPTY_ARRAY;
export const filtersSelector = (state) => state.videoService.filters || EMPTY_OBJECT;

export const packageListIsLoadingSelector = (state) => state.videoService.isLoading || false;
export const selectedPackageIdsSelector = (state) =>
    state.videoService.selectedPackageIds || EMPTY_ARRAY;

export const selectedPackageDataSelector = createSelector(
    packageListSelector,
    selectedPackageIdsSelector,
    (packages, selectedPackageIds) => {
        if (!selectedPackageIds?.length) {
            return EMPTY_OBJECT;
        }
        const firstSelectedId = selectedPackageIds[0];
        const selectedPackage = packages.find((p) => p.id === firstSelectedId);
        return selectedPackage || EMPTY_OBJECT;
    }
);
